import type { MarketSelectorItem, MarketSelectorPreset } from '../../../../MarketSelector/types';
import { getItemsFromPreset } from '../../../../MarketSelector/useMarketSelector';
import { isMarketSelectorItemSelectable } from '../../../../MarketSelector/utils/items';

export function getSelectableMarketItemNames(
  presetID: string,
  aggregationPresetsByID: Map<string, MarketSelectorPreset> | undefined,
  itemsMap: Map<string, MarketSelectorItem>
) {
  const presetItems = getItemsFromPreset(presetID, aggregationPresetsByID, itemsMap);
  const selectablePresetItems = presetItems.filter(isMarketSelectorItemSelectable);
  const selections = selectablePresetItems.map(item => item.name);
  return selections;
}
